import * as React from "react";
const SvgFiRrHeartArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-heart-arrow_svg__a)">
      <path
        fill="#062147"
        d="M23 17a1 1 0 0 0-1 1v2.586l-2.994-2.994C21.2 15.25 23 12.547 23 9.987a5.745 5.745 0 0 0-5.5-5.949A5.39 5.39 0 0 0 13 6.57a5.39 5.39 0 0 0-4.5-2.532 5.1 5.1 0 0 0-2.428.62L1.707.292A1 1 0 0 0 .293 1.707L4.5 5.915A6.2 6.2 0 0 0 3 9.987c0 3.791 3.951 7.9 7.265 10.676a4.25 4.25 0 0 0 5.47 0 42 42 0 0 0 1.861-1.654L20.586 22H18a1 1 0 0 0 0 2h4a2 2 0 0 0 2-2v-4a1 1 0 0 0-1-1m-8.55 2.132a2.31 2.31 0 0 1-2.9 0C7.387 15.643 5 12.31 5 9.987a3.75 3.75 0 0 1 3.5-3.949 3.75 3.75 0 0 1 3.5 3.95 1 1 0 0 0 2 0 3.75 3.75 0 0 1 3.5-3.95 3.75 3.75 0 0 1 3.5 3.95c0 2.321-2.388 5.654-6.55 9.144"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-heart-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHeartArrow;
